import { render, staticRenderFns } from "./qHeader.vue?vue&type=template&id=b045a562&"
import script from "./qHeader.vue?vue&type=script&lang=ts&"
export * from "./qHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports